import { ImgRoute } from "contents/Images";
import React from "react";
import styled from "styled-components";

type ImgProps = {
  src: keyof typeof ImgRoute;
};

export const Img = ({ src }: ImgProps) => {
  return <StyledImg src={ImgRoute[src]} alt={src} />;
};

const StyledImg = styled.img`
  width: max-content;
  max-width: 100%;
  max-height: 18rem;
`;
